import throttle from 'lodash/throttle';

import { ONE_SECOND } from 'Lib/constants/time';
import { createAction } from 'Lib/reduxUtils';

import type { UserProfile } from 'Store/entities/types';

import {
  FAST_MATCH_DISLIKE,
  FAST_MATCH_LIKE,
  FAST_MATCH_SUPERLIKE,
  FETCH_LIKES_YOU_COUNT,
  FETCH_LIKES_YOU_COUNT_ERROR,
  FETCH_LIKES_YOU_COUNT_REQUEST,
  FETCH_LIKES_YOU_COUNT_SUCCESS,
  FETCH_LIKES_YOU_PREVIEW,
  FETCH_LIKES_YOU_PREVIEW_ERROR,
  FETCH_LIKES_YOU_PREVIEW_REQUEST,
  FETCH_LIKES_YOU_PREVIEW_SUCCESS,
  FETCH_LIKES_YOU_RECS,
  FETCH_LIKES_YOU_RECS_ERROR,
  FETCH_LIKES_YOU_RECS_REQUEST,
  FETCH_LIKES_YOU_RECS_SUCCESS,
  FETCH_LIKES_YOU_TEASERS,
  FETCH_LIKES_YOU_TEASERS_ERROR,
  FETCH_LIKES_YOU_TEASERS_REQUEST,
  FETCH_LIKES_YOU_TEASERS_SUCCESS,
  SET_GOLD_HOME_SEEN,
  SET_LAST_GOLD_HOME_TAB,
  SET_NEW_LIKES_COUNT,
  SET_NEW_LIKES_COUNT_SUCCESS,
  SET_PREVIOUS_SESSION_LIKES_COUNT,
  SHOW_NEW_LIKES_CELEBRATION_MODAL,
  UPDATE_LIKES_YOU_COUNT,
} from './constants';
import type { LikesYouPayload } from './types';

const THROTTLE_TIME = 5 * ONE_SECOND;

export const fetchLikesYouPreview = createAction(FETCH_LIKES_YOU_PREVIEW);
export const fetchLikesYouPreviewRequest = createAction(FETCH_LIKES_YOU_PREVIEW_REQUEST);
export const fetchLikesYouPreviewSuccess = createAction(
  FETCH_LIKES_YOU_PREVIEW_SUCCESS,
  (payload: LikesYouPayload) => payload
);
export const fetchLikesYouPreviewError = createAction(FETCH_LIKES_YOU_PREVIEW_ERROR);
export const throttledFetchLikesYouPreview = throttle(
  fetchLikesYouPreview,
  THROTTLE_TIME
) as typeof fetchLikesYouPreview;

export const fetchLikesYouRecs = createAction(FETCH_LIKES_YOU_RECS, (nextPage?: boolean) => ({
  nextPage,
}));
export const fetchLikesYouCount = createAction(FETCH_LIKES_YOU_COUNT);
export const fetchLikesYouCountRequest = createAction(FETCH_LIKES_YOU_COUNT_REQUEST);
export const fetchLikesYouCountSuccess = createAction(
  FETCH_LIKES_YOU_COUNT_SUCCESS,
  (payload: LikesYouPayload) => payload
);
export const fetchLikesYouCountError = createAction(FETCH_LIKES_YOU_COUNT_ERROR);
export const updateLikesYouCount = createAction(UPDATE_LIKES_YOU_COUNT);

export const fetchLikesYouRecsRequest = createAction(FETCH_LIKES_YOU_RECS_REQUEST);
export const fetchLikesYouRecsSuccess = createAction(
  FETCH_LIKES_YOU_RECS_SUCCESS,
  (normalizedData: LikesYouPayload, replaceResults: boolean = true) => ({
    replaceResults,
    ...normalizedData,
  })
);

export const fetchLikesYouRecsError = createAction(FETCH_LIKES_YOU_RECS_ERROR);
export const throttledFetchLikesYouRecs = throttle(
  fetchLikesYouRecs,
  THROTTLE_TIME
) as typeof fetchLikesYouRecs;

export const fetchLikesYouTeasers = createAction(FETCH_LIKES_YOU_TEASERS);
export const fetchLikesYouTeasersRequest = createAction(FETCH_LIKES_YOU_TEASERS_REQUEST);
export const fetchLikesYouTeasersSuccess = createAction(
  FETCH_LIKES_YOU_TEASERS_SUCCESS,
  (payload: LikesYouPayload) => payload
);
export const fetchLikesYouTeasersError = createAction(FETCH_LIKES_YOU_TEASERS_ERROR);
export const throttledFetchLikesYouTeasers = throttle(
  fetchLikesYouTeasers,
  THROTTLE_TIME
) as typeof fetchLikesYouTeasers;

// add isFastMatch flag
export const fastMatchLike = createAction(
  FAST_MATCH_LIKE,
  (payload: { method?: string; recUser: UserProfile; isBouncerEnabled?: boolean }) => payload
);
export const fastMatchDislike = createAction(
  FAST_MATCH_DISLIKE,
  (payload: { method?: string; recUser: UserProfile; isBouncerEnabled?: boolean }) => payload
);
export const fastMatchSuperlike = createAction(
  FAST_MATCH_SUPERLIKE,
  (payload: { method?: string; recUser: UserProfile; isBouncerEnabled?: boolean }) => payload
);

export const setLastGoldHomeTab = createAction(SET_LAST_GOLD_HOME_TAB, (tabName: string) => ({
  tabName,
}));
export const showNewLikesCelebrationModal = createAction(SHOW_NEW_LIKES_CELEBRATION_MODAL);
export const setGoldHomeSeen = createAction(SET_GOLD_HOME_SEEN);
export const setNewLikesCount = createAction(SET_NEW_LIKES_COUNT);
export const setNewLikesCountSuccess = createAction(
  SET_NEW_LIKES_COUNT_SUCCESS,
  (newLikesCount: number) => ({ newLikesCount })
);
export const setPrevSessionLikesCount = createAction(
  SET_PREVIOUS_SESSION_LIKES_COUNT,
  (prevSessionLikeCount: number) => ({ prevSessionLikeCount })
);
